import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { BackdropContainerInterface, StaticVerticalSize, ThemeScroll } from '../FeatureAppTypes';
import { useBreakpoint } from '../utils/use-breakpoint';

const BackdropContainer = styled.div<BackdropContainerInterface>`
  background: ${({ backdropColor }) => backdropColor};
  padding-top: ${({ padding }) => padding}px;
  padding-bottom: ${({ padding }) => padding}px;
`;

interface Props extends PropsWithChildren {
  theme: ThemeScroll;
}

export const StaticBackdrop: React.FC<Props> = ({ children, theme }) => {
  const breakpoint = useBreakpoint(theme);
  const { breakpoints, colors } = theme;

  const breakpointVerticalMap: { [key: number]: StaticVerticalSize } = {
    [breakpoints.s]: StaticVerticalSize.S,
    [breakpoints.m]: StaticVerticalSize.M,
    [breakpoints.l]: StaticVerticalSize.L,
    [breakpoints.xl]: StaticVerticalSize.XL,
    [breakpoints.xxl]: StaticVerticalSize.XXL,
  };

  const backdropColor = colors.colorCanvas200;

  return (
    <BackdropContainer backdropColor={backdropColor} padding={breakpointVerticalMap[breakpoint]}>
      {children}
    </BackdropContainer>
  );
};
